import React, { useEffect } from "react";
import SimilerBanner from "../components/similerBanner/SimilerBanner";
import DevelopingSolution from "../components/developingsolution/DevelopingSolution";
import Testimonial from "../components/testimonila/Testimonial";
import CoverTheStack from "../components/coverthestack/CoverTheStack";
import SecondFaq from "../components/secondFaq/SecondFaq";
import Footer from "../components/footer/Footer";
import { Helmet } from "react-helmet";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import TrendsInsights from "../components/trends-n-insights/TrendsInsights";
import RoadMap from "../components/roadMap/RoadMap";
import WhoWeServe from "../components/who-we-serve/WhoWeServe";
import HighValues from "../components/high-values/HighValues";
import TypesOfBuild from "../components/types-of-build/TypesOfBuild";
import WhyChooseBitsclan from "../components/why-choose-bitsclan/WhyChooseBitsclan";
import IndustriesTabs from "../components/industries-tabs/IndustriesTabs";
import { IndustryTabsData } from "../data/industriesTabsData";
import DevelopmentServices from "../components/development-services/DevelopmentServices";
import ContactSection from "../components/contactSection/ContactSection";
import { WebServicesIndustryTabsItemsData } from "../data/web-app-service-page";
import NewEngagementModels from "../components/new-engagment-modal";
import {
  DevelopmentServicesData,
  faqData,
  HighvaluesData,
  mainBannerImg,
  schemaData,
  tabItems,
  tabs,
  TypesOfBuildData,
  WhoWeServeData,
  WhyChooseBitsclanData,
} from "../data/software-quality-assurence-data";
import { useTranslation } from "react-i18next";
import SimpleModels from "../components/simpleEngagementModels";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import MegaMenu from "../components/MegaMenu/MegaMenu";
import NewCaseStudySection from "../components/new-case-study-section/NewCaseStudySection";

const MobileDevelopmentServices = () => {
  const { t } = useTranslation("softwareQualityAssurencePage");
  const BannerContent = t("pageBanner", { returnObjects: true });
  const servicesContet = t("pageServicesData", { returnObjects: true });
  const accordianContent = t("pageTypesOfBuildData", { returnObjects: true });
  const whoWeServeContent = t("pageWhoWeServeCards", { returnObjects: true });
  const chooseUsContent = t("pageChooseUs", { returnObjects: true });
  const highValueContent = t("pageHighValueCards", { returnObjects: true });
  const QARoadMapData = t("pageRoadMap", { returnObjects: true });
  const coverTheStackContent = t("pageCoverTheStack", { returnObjects: true });
  const industriesHeading = t("pageIndustriesHeading", { returnObjects: true });
  const faqData = t("pageFaqData", { returnObjects: true });

  const { t: tmetaTitles } = useTranslation("metaTitles");
  const metaTitle = tmetaTitles("qaMetaTitle", { returnObjects: false });

  const { t: tengagementModelContent } = useTranslation(
    "engagementModelContent"
  );

  // grab the full object once
  const engagementModelsContent = {
    heading: tengagementModelContent("heading"),
    darkHeading: tengagementModelContent("darkHeading"),
    subheading: tengagementModelContent("subheading"),
    models: tengagementModelContent("models", { returnObjects: true }),
    cta: tengagementModelContent("cta", { returnObjects: true }),
  };

  const { t: tfooter } = useTranslation("footer");
  const footerCtaContent = tfooter("footerCtaContent", {
    returnObjects: true,
  });
  return (
    <>
      <Helmet>
        <title>{metaTitle}</title>
        <meta
          name="description"
          content="Ensure flawless software performance with our comprehensive quality assurance & testing services tailored for perfection"
        />
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      </Helmet>

      <MegaMenu />

      <SimilerBanner
        diffBannerBackgroundImage={mainBannerImg}
        mainHeading={BannerContent?.mainHeading}
        greenHeading={BannerContent?.greenHeading}
        subHeading={BannerContent?.subHeadingGreen}
        content={BannerContent?.sectionDescription}
        btnText2={BannerContent?.buttonText}
        sideImage={""}
      />

      <NewCaseStudySection shortHeading="Our case studies" heading="Trusted by the World's Leading Companies" description="Partner with Bitsclan’s skilled development teams for AI, web, mobile, & enterprise solutions. Our proven offshore software development approach delivers exceptional results, blending innovation & scalability to drive lasting business success across industries." />

      <DevelopmentServices
        tabs={servicesContet?.tabsData}
        heading={servicesContet?.sectionContent?.mainHeading}
        subheading={servicesContet?.sectionContent?.sectionDescription}
      />

      <TypesOfBuild
        typeOfApps={accordianContent?.accordianData}
        heading={accordianContent?.mainHeading}
        sideImage="software-quality-assurence.avif"
      />

      <WhoWeServe
        cardContent={whoWeServeContent?.cardsData}
        heading={whoWeServeContent?.sectionContent?.mainHeading}
        subHeading={whoWeServeContent?.sectionContent?.sectionDescription}
      />

      <WhyChooseBitsclan
        tabs={chooseUsContent?.tabsData}
        expandAllAccordions={true}
        heading={chooseUsContent?.sectionContent?.mainHeading}
        subheading={chooseUsContent?.sectionContent?.sectionDescription}
      />

      <HighValues
        heading={highValueContent?.mainHeading}
        subHeading={highValueContent?.sectionDescription}
        boxContent={highValueContent?.cardsData}
        btnLink="#"
        btnText={highValueContent?.buttonText}
      />

      {/* <NewEngagementModels /> */}
      <SimpleModels content={engagementModelsContent} />

      <RoadMap
        heading={QARoadMapData?.heading}
        description={QARoadMapData?.description}
        roadMapsteps={QARoadMapData?.roadMapsteps}
        roadMapHeading={QARoadMapData?.roadMapHeading}
      />

      <CoverTheStack
        whereStart={coverTheStackContent?.defaultTabOpen}
        mainHeading={coverTheStackContent?.mainHeading}
        subHeading={coverTheStackContent?.sectionDescription}
        tabs={coverTheStackContent?.tabs}
        tabItems={coverTheStackContent?.tabItems}
      />

      <IndustriesTabs
        mainheading={industriesHeading?.mainHeading}
        tabs={IndustryTabsData}
        defaultTab={"Healthcare"}
        tabsItems={WebServicesIndustryTabsItemsData}
      />

      <DevelopingSolution
        heading="Developing Solutions That Transcend Mere Digital Transformation"
        subheading="We deliver innovative solutions that surpass digital transformation, driving impactful & lasting success."
      />

      <TrendsInsights
        specificClass="mobile-dev-page"
        category="quality-assurance-services"
      />

      <SecondFaq
        specificClass="mobile-dev-page"
        faqs={faqData?.questionAnswer}
        mainHeading={faqData?.mainHeading}
        subHeading={faqData?.sectionDescription}
      />

      {/* <ContactSection /> */}

      <SoftwareCompanyCta content={footerCtaContent} />

      <Footer />
    </>
  );
};

export default MobileDevelopmentServices;
